import axios from 'axios';

export const myAccountApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/my-account`,
    headers: {
        'Content-Type': 'application/json'
    }
})